export enum PhotoGalleryTypeEnum {
    GALLERY = 'gallery',
    SLIDESHOW = 'slideshow',
    SQUARED_GALLERY = 'squaredGallery',
}
